
define('template!phoneCallsRecordView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="call-record-view-body">\n  <audio class="content" controls preload="auto"></audio>\n  <div class="call-record-actions">\n    <a class="download-link btn btn-primary" target="_blank" download>' +
((__t = ( _.i18n('common.download') )) == null ? '' : __t) +
'</a>\n  </div>\n</div>\n';

}
return __p
};});

